








import Login from '@/components/login/Login.vue';
import LoginHeader from '@/components/login/LoginHeader.vue';
import Footers from '@/components/Footers.vue';
import {Vue, Component} from 'vue-property-decorator';

@Component({
  components: {Login, LoginHeader, Footers}
})
export default class DefaultView extends Vue {}
